<template>
  <div id="insightsCohorts">
    <div class="margin-subpages">
      <div class="flex">
        <el-select
          v-model="selectTeam"
          filterable
          :placeholder="$t('insights.Select')"
          class="input-style"
          :class="[ blurMode ?  'blurelement': '' ]"
          @change="changMainPageData"
        >
          <el-option
            class="text-dropdown"
            key="all"
            :label="`${$t('insights.All_Cohorts')} (${$utils(
              'addCommasInNumber',
              optionsCohort.length
            )})`"
            value="all"
          ></el-option>
          <el-option
            class="text-dropdown"
            :class="[ blurMode ?  'blurelement': '' ]"
            v-for="item in optionsCohort"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
      <div class="headerCard">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{
            $t("insights.HAPPINESS_VS_RISK_RATE")
          }}</span>
        </div>
        <div class="pr-12 mt-11">
          <span class="fc-4A4A4A">{{ $t("insights.Duration") }}</span>
        </div>
        <div class="showOption">
          <el-menu
            class="el-menu-demo menuOptionStyle"
            mode="horizontal"
            style="width: 200px"
          >
            <el-submenu index="0" style="width: 200px">
              <template slot="title">
                <span class="txtOption2">{{ selectMainPageMonth }}</span>
              </template>
              <el-menu-item
                index="1"
                @click="handleMainPageMonth('30-days')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_30_days") }}</el-menu-item
              >
              <el-menu-item
                index="2"
                @click="handleMainPageMonth('60-days')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_60_days") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('13-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_13_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('26-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_26_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('52-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_52_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('24-months')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_24_months") }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
        <div class="pl-10">
          <svg
            @click="exportChart('mainPage')"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
        </div>
      </div>
      <div class="chart-bar relative">
        <div
          class="loading-chart-bar flex-mid pt-1"
          v-if="loadingMainChart"
        >
          <loading-even></loading-even>
        </div>
        <div class="flex-mid" v-else>
          <div class="chart-type-bar green ml-16"></div>
          <div class="type-bar-text">{{ $t("insights.HAPPINESS") }}</div>
          <div class="chart-type-bar red"></div>
          <div class="type-bar-text">{{ $t("insights.RISK") }}</div>
          <div class="chart-type-bar line">
            <div></div>
          </div>
          <div class="type-bar-text">{{ $t("insights.ACTIVE_USERS") }}</div>
        </div>
        <div
          v-if="!loadingMainChart && Object.keys(this.datachart).length == 0"
          class="absolute-mid"
          style="height: 197px; width: 100%"
        >
          <img
            class="absolute-mid"
            src="@/assets/images/insights/bar_chart_empty_state.png"
          />
          <div class="absolute-mid center fs-12 fw-500" style="width: 100%">
            {{ $t("insights.There_is_no_happiness") }}
          </div>
        </div>
        <div style="height: 180px">
          <canvas ref="CohortsChart"></canvas>
        </div>
      </div>
      <!-- <div class="flex">
        <div class="headerCard" style="padding-bottom: 9px;">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">Most Engaged</span>
          <img :src="getImgUrl('help_outline-16px')">
        </div>
        </div>
      </div>-->
      <div class="headerCard2">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{ $t("insights.COHORT_STATUS") }}</span>
        </div>
        <div class="search-container">
          <el-input
            v-model="searchFilter"
            :placeholder="$t('insights.Search_cohorts_placeholder')"
            class="search-input"
            clearable
            @input="handleSearchInput"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div style="padding-right: 12px; margin-top: 10px">
          <span class="fc-4A4A4A">{{ $t("insights.Sort_by") }}</span>
        </div>
        <div class="showOption">
          <el-menu
            class="el-menu-demo menuOptionStyle"
            mode="horizontal"
            style="width: 200px"
          >
            <el-submenu :index="`${selectMainPageSort}`" style="width: 200px">
              <template slot="title">
                <span class="txtOption2">{{
                  optionsSort[selectMainPageSort]
                }}</span>
              </template>
              <el-menu-item
                v-for="(value, key) in optionsSort"
                :key="`MAIN_PAGE-${key}`"
                :index="`${key}`"
                @click="sortByMainPage"
                style="font-size: 16px; width: 200px"
                >{{ value }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="divTable" style="min-height: 300px">
        <el-table
          id="cohortsTable"
          :data="filteredDatalist"
          max-height="720"
          :empty-text="
            showMainTableLoading
              ? ' '
              : $t('insights.No_data_for_time_period')
          "
          ref="cohortsTable"
          style="width: 100%"
          :cell-style="cellStyle"
          row-key="id"
          lazy
          :expand-row-keys="expandkay"
          :load="load"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            :remote="remoteMainPage"
            prop="team"
            label-class-name="labelCohortTable"
            class-name="cell-with-nowrap"
            :label="$t('insights.Cohorts')"
          ></el-table-column>
          <el-table-column
            :label="$t('insights.Happiness_Rate')"
            width="90"
            label-class-name="labelRateTable"
            class-name="line-break"
            align="right"
          >
          <template slot="header">
              <el-tooltip :content="$t('insights.Happiness_Rate_tooltip')" placement="top">
                <span>{{ $t('insights.Happiness_Rate') }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.happirate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Risk_Rate')"
            width="58"
            align="right"
            label-class-name="labelRateTable"
            class-name="line-break"
          >
          <template slot="header">
              <el-tooltip :content="$t('insights.Risk_Rate_tooltip')" placement="top">
                <span>{{ $t('insights.Risk_Rate') }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.riskrate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Feedback')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.feedback }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Wellness')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.wellness }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Manager')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.manager }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Recognition')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="46"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.recognition }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Ambassadorship')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{
                    'background-color': scope.row.ambassadorship,
                  }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Colleagues')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.colleagues }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Personal_Growth')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.personal }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Co_Alignment')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.alignment }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Satisfaction')"
            :render-header="renderPhaseHeader"
            label-class-name="labelTable"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  v-bind:style="{ 'background-color': scope.row.satisfaction }"
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="12">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            :label="$t('insights.Avg_Impact')"
            width="60"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip :content="$t('insights.Avg_Impact_tooltip')" placement="top">
                <span>{{ $t('insights.Avg_Impact') }}</span>
              </el-tooltip>
            </template>
            <template  slot-scope="scope">
              <div class="flex-mid">
                <div
                  class="impact-tag px-2 fw-700"
                  :class="`impact-tag-${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ?  'gray' : scope.row.avgimpact_color}`"
                  style="line-height: 18px; font-size: 12px; width: 50px;"
                >
                  {{ (scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ? '-' : Math.round(scope.row.avgimpact) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            width="68"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
            <template slot="header">
              <el-tooltip :content="$t('insights.DEBI_Score_tooltip')" placement="top">
                <span>{{ $t('insights.DEBI_Score') }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          {{ $t('insights.ENGAGEMENT_SCORE') }}
                        </div>
                        <div class="fs-11 mt-4">
                          {{ $t('insights.DEBI_by_role') }}
                        </div>
                          <div v-if="!loadingDataEngagement" style="justify-content: flex-start">
                            <div class="flex">
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">{{ $t('insights.overall_label') }}</div>
                                  <div class="symbol blue"></div>
                                  <div class="score">{{ (databarchartEngagementScore['cohort'] && databarchartEngagementScore['cohort_members'] && databarchartEngagementScore['cohort_members'][databarchartEngagementScore['cohort_members'].length - 1] > 0) ? databarchartEngagementScore['cohort'][databarchartEngagementScore['cohort'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">{{ $t('insights.Manager') }}</div>
                                  <div class="symbol orange"></div>
                                  <div class="score">{{ (databarchartEngagementScore['manager'] && databarchartEngagementScore['manager_members'] && databarchartEngagementScore['manager_members'][databarchartEngagementScore['manager_members'].length - 1] > 0) ? databarchartEngagementScore['manager'][databarchartEngagementScore['manager'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">{{ $t('insights.Leader') }}</div>
                                  <div class="symbol pink"></div>
                                  <div class="score">{{ (databarchartEngagementScore['leader'] && databarchartEngagementScore['leader_members'] && databarchartEngagementScore['leader_members'][databarchartEngagementScore['leader_members'].length - 1] > 0) ? databarchartEngagementScore['leader'][databarchartEngagementScore['leader'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingDataEngagement"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="`engagement_${scope.row.id}`"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainEngagementTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${detectColorTotal(scope.row.engagement_score)}`"
                    style="line-height: 18px; font-size: 12px; width: 50px; margin-left: 14px;"
                  >
                  {{
                  `${(scope.row.engagement_score !== undefined && !isNaN(scope.row.engagement_score)) ? Math.round(scope.row.engagement_score) : scope.row.engagement_score}`
                  }}
                  </div>
               
                </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            :label="$t('insights.Six_mo_Retention')"
            width="80"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip :content="$t('insights.Six_mo_Retention_tooltip')" placement="top">
                <span>{{ $t('insights.Six_mo_Retention') }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          {{ $t('insights.ARCHIVED_MEMBERS_HISTORY') }}
                        </div>
                        <div class="fs-11 mt-4">
                          {{ $t('insights.Number_of_archived_by_month') }}
                        </div>
                      </div>
                      <div class="ml-auto fs-11">
                        <div class="flex-center">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #FFBCB7;
                            "
                          >&nbsp;</div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">{{ $t('insights.Terminated') }}</div>
                        </div>
                        <div class="flex-center mt-4">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #f44336;
                            "
                          >&nbsp;</div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">{{ $t('insights.Resigned') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="pt-20 relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingChartInTable"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="scope.row.id"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ?  'gray' : scope.row.retention_color}`"
                    style="line-height: 18px; font-size: 12px; width: 50px;"
                  >
                    {{ (scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ? '-' : Math.round(scope.row.retention_rate) + '%' }}
                  </div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="6">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="center mt-20 mb-40 pt-20 pb-40"
          v-if="showMainTableLoading"
        >
          <loading-even></loading-even>
        </div>
        <download-progress
          :wording="wordingSnackBar"
          :active="showSnackbar"
        ></download-progress>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import chartDataResignedLabels from "chartjs-plugin-datalabels";
import getDay from "date-fns/get_day";
import addDays from "date-fns/add_days";
import addMonths from "date-fns/add_months";
import startOfWeek from "date-fns/start_of_week";
import subWeeks from "date-fns/sub_weeks";
import lastDayOfWeek from "date-fns/last_day_of_week";

export default {
  name: "cohorts",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  async created() {
    await this.initializeCohortsView();
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    expandProps() {
      return this.$store.getters["navCommands/getExpandProps"];
    },
    optionsCohort() {
      return this.$store.getters["insightsCohorts/optionsCohort"];
    },
    datachart() {
      return this.$store.getters["insightsCohorts/datachart"];
    },
    datalist() {
      return this.$store.getters["insightsCohorts/datalist"];
    },
    filteredDatalist() {
      const datalist = Array.isArray(this.datalist) ? this.datalist : [];
      if (!this.searchFilter) {
        return datalist;
      }

      const searchTerms = this.searchFilter
        .toLowerCase()
        .split(",")
        .map((term) => term.trim())
        .filter((term) => term);

      if (searchTerms.length === 0) {
        return datalist;
      }

      return datalist.filter((row) => {
        const teamName = row.team ? row.team.toLowerCase() : "";
        return searchTerms.some((term) => teamName.includes(term));
      });
    },
    showMainTableLoading() {
      return this.loadingMainData;
    },
    showSnackbar() {
      return this.$store.getters["insightsCohorts/showSnackbar"];
    },
    loadingDataEngagement() {
      return this.$store.getters["insightsCohorts/loadingDataEngagement"];
    },
    databarchartEngagementScore() {
      return this.$store.getters["insightsCohorts/databarchartEngagementScore"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    optionsSort() {
      return [
        this.$t("insights.Lowest_Happiness"),
        this.$t("insights.Highest_Happiness"),
        this.$t("insights.Lowest_Risk"),
        this.$t("insights.Highest_Risk"),
      ];
    },
  },
  data() {
    return {
      wordingSnackBar: this.$t("insights.Preparing_cohort_data"),
      activeWhere: {},
      expands: [],
      selectTeam: "all",
      selectMainPageMonth: "60-days",
      selectMainPageMonthKey: "60-days",
      optionsMainPageMonthName: [],
      optionsMainPageMonth: [],
      myChart: "",
      selectMainPageSort: 0,
      spotlightCohortStatus: false,
      dataAllList: [],
      cohortStatusChanged: true,
      dataMainPageChanged: true,
      newLabels: [],
      newLabelsfulldate: [],
      realDataMainTreeTable: [],
      expandkay: [],
      loadingChartInTable: false,
      barChartTooltipBarChartOnMain: null,
      barChartTooltipBarChartOnMainEngagement: null,
      hoverCohort: "",
      searchFilter: "",
      viewMounted: false,
      loadingMainData: true,
      loadingMainChart: true,
      mainScopeRequestId: 0,
      mainChartRequestId: 0,
    };
  },
  mounted() {
    this.viewMounted = true;
    this.$nextTick(() => {
      if (Object.keys(this.datachart || {}).length > 0) {
        this.randerMainPageChart();
      }
    });
  },
  beforeDestroy() {
    this.destroyAllCharts();
  },
  watch: {
    databarchartEngagementScore() {
      if (this.barChartTooltipBarChartOnMainEngagement)
        this.barChartTooltipBarChartOnMainEngagement.destroy();
      this.generateChartTooltipOnMainEngagement();
    },
    datachart() {
      if (this.myChart && this.dataMainPageChanged) {
        this.myChart.destroy();
      }
      if (this.viewMounted && Object.keys(this.datachart || {}).length > 0) {
        this.randerMainPageChart();
      }
    },
    datalist: {
      immediate: true,
      handler(value) {
        this.dataAllList = Array.isArray(value) ? value : [];
      },
    },
  },
  methods: {
    getDefaultCohortSelection() {
      return "all";
    },
    getInitialCohortSelection() {
      if (
        this.expandProps.navCall &&
        this.expandProps.memberObject &&
        this.expandProps.memberObject.key
      ) {
        return this.expandProps.memberObject.key;
      }

      return this.getDefaultCohortSelection();
    },
    getInitialMainPeriodKey() {
      if (
        this.expandProps.navCall &&
        this.expandProps.expandTime &&
        this.expandProps.expandTime.key
      ) {
        return this.expandProps.expandTime.key;
      }

      return this.selectMainPageMonthKey;
    },
    nextMainScopeRequestId() {
      const requestId = this.mainScopeRequestId + 1;
      this.mainScopeRequestId = requestId;
      this.$store.commit("insightsCohorts/setMainRequestKey", requestId);
      return requestId;
    },
    nextMainChartRequestId() {
      const requestId = this.mainChartRequestId + 1;
      this.mainChartRequestId = requestId;
      this.$store.commit("insightsCohorts/setMainChartRequestKey", requestId);
      return requestId;
    },
    resetMainTableExpansion() {
      const tableRef = this.$refs.cohortsTable;
      if (tableRef && tableRef.store && tableRef.store.states) {
        tableRef.store.states._treeRowExpanded = [];
      }
    },
    destroyAllCharts() {
      if (this.myChart) {
        this.myChart.destroy();
        this.myChart = null;
      }
      if (this.barChartTooltipBarChartOnMain) {
        this.barChartTooltipBarChartOnMain.destroy();
        this.barChartTooltipBarChartOnMain = null;
      }
      if (this.barChartTooltipBarChartOnMainEngagement) {
        this.barChartTooltipBarChartOnMainEngagement.destroy();
        this.barChartTooltipBarChartOnMainEngagement = null;
      }
    },
    buildPeriodConfig(optMonth) {
      const newDate = new Date();
      let textOption = this.$t("insights.Last_24_months");
      const optionNames = [];
      const options = [];
      const labels = [];
      const fullLabels = [];
      let activeWhere = {};

      if (optMonth == "30-days" || optMonth == "60-days") {
        const totalDays = optMonth == "30-days" ? 30 : 60;
        textOption =
          optMonth == "30-days"
            ? this.$t("insights.Last_30_days")
            : this.$t("insights.Last_60_days");
        activeWhere = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -totalDays), "YYYY-MM-DD"),
        };

        newDate.setDate(newDate.getDate() - 1);
        for (let i = totalDays; i > 0; i--) {
          const currentDate = addDays(newDate, -(i - 1));
          const day = getDay(currentDate);
          if (day != 0 && day != 6) {
            optionNames.push(
              i % 7 === 0 ? this.$dateFns.format(currentDate, "DD MMM") : ""
            );
            labels.push(this.$dateFns.format(currentDate, "DD MMM"));
            fullLabels.push(this.$dateFns.format(currentDate, "DD MMMM"));
            options.push({
              startdate: this.$dateFns.format(currentDate, "YYYY-MM-DD"),
              enddate: this.$dateFns.format(currentDate, "YYYY-MM-DD"),
            });
          }
        }
      } else if (
        optMonth == "13-weeks" ||
        optMonth == "26-weeks" ||
        optMonth == "52-weeks"
      ) {
        let week = 13;
        if (optMonth == "13-weeks") {
          textOption = this.$t("insights.Last_13_weeks");
        } else if (optMonth == "26-weeks") {
          textOption = this.$t("insights.Last_26_weeks");
          week = 26;
        } else {
          textOption = this.$t("insights.Last_52_weeks");
          week = 52;
        }

        const startOfCurrentWeek = this.$dateFns.format(
          addDays(startOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );
        const endOfCurrentWeek = this.$dateFns.format(
          addDays(lastDayOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );

        for (let j = week - 1; j >= 0; j--) {
          const startweek = this.$dateFns.format(
            subWeeks(startOfCurrentWeek, j),
            "YYYY-MM-DD"
          );
          const lastweek = this.$dateFns.format(
            subWeeks(endOfCurrentWeek, j),
            "YYYY-MM-DD"
          );

          options.push({
            startdate: startweek,
            enddate: lastweek,
          });
          optionNames.push(this.$dateFns.format(startweek, "D MMM").toUpperCase());
          labels.push(this.$dateFns.format(startweek, "DD MMM"));
          fullLabels.push(this.$dateFns.format(startweek, "DD MMMM"));
        }

        if (options.length) {
          activeWhere = {
            type: "weeks",
            start: options[0].startdate,
          };
        }
      } else {
        for (let i = 23; i >= 0; i--) {
          const startDate = this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM");
          optionNames.push(
            this.$dateFns.format(addMonths(newDate, -i), "MMM").toUpperCase()
          );
          options.push({
            startdate: startDate + "-01",
            enddate: startDate + "-31",
          });
          labels.push(startDate);
          fullLabels.push(startDate);
        }

        if (options.length) {
          activeWhere = {
            type: "months",
            start: options[0].startdate,
          };
        }
      }

      return {
        key: optMonth,
        textOption,
        optionNames,
        options,
        labels,
        fullLabels,
        activeWhere,
      };
    },
    applyMainPeriodConfig(optMonth) {
      const config = this.buildPeriodConfig(optMonth);
      this.selectMainPageMonthKey = config.key;
      this.selectMainPageMonth = config.textOption;
      this.optionsMainPageMonthName = config.optionNames;
      this.optionsMainPageMonth = config.options;
      this.newLabels = config.labels;
      this.newLabelsfulldate = config.fullLabels;
      this.activeWhere = config.activeWhere;
      return config;
    },
    async initializeCohortsView() {
      this.loadingMainData = true;
      this.loadingMainChart = true;
      this.selectTeam = this.getInitialCohortSelection();
      this.applyMainPeriodConfig(this.getInitialMainPeriodKey());
      this.$store.commit("insightsCohorts/setDataTable", []);
      this.$store.commit("insightsCohorts/setChartHappyRisk", []);

      const cohortsState = this.$store.state.insightsCohorts;
      const metadataLoads = [];

      if (!this.optionsCohort || this.optionsCohort.length === 0) {
        metadataLoads.push(
          this.$store.dispatch("insightsCohorts/getOptionsCohort", this.user)
        );
      }

      if (
        !cohortsState.insightcohortsByComp ||
        cohortsState.insightcohortsByComp.length === 0 ||
        !cohortsState.datalistall ||
        cohortsState.datalistall.length === 0
      ) {
        metadataLoads.push(
          this.$store.dispatch("insightsCohorts/getInsightCohortsByComp")
        );
      }

      await Promise.all(metadataLoads);
      await this.refreshMainScope(this.selectTeam);
    },
    randerMainPageChart() {
      const chart = this.$refs.CohortsChart;
      if (!chart || !this.dataMainPageChanged || !this.datachart.happy) {
        return;
      }

      const ctx = chart.getContext("2d");
      const happyData = [...this.datachart.happy];
      const riskData = [...this.datachart.risk];

      if (this.dataMainPageChanged && this.datachart.happy) {
        let maxRiskLevel = -20;
        for (let i = 0; i < riskData.length; i++) {
          if (riskData[i] > 0) {
            riskData[i] = riskData[i] * -1;
          }
          if (riskData[i] < maxRiskLevel) {
            maxRiskLevel = riskData[i];
          }
        }
        const backgroundColorBar = [];
        const borderColorBar = [];
        for (let i = 0; i < this.datachart.activeuser.length; i++) {
          if (happyData[i] === 0 && riskData[i] === 0) {
            happyData[i] = 2;
            borderColorBar.push("#747474");
            backgroundColorBar.push("#747474");
          } else {
            borderColorBar.push("#3AC47D");
            backgroundColorBar.push("#3AC47D");
          }
        }
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: maxRiskLevel,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.8,
            borderRadius: 4,
            borderSkipped: false,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabels[tooltipItems[0].dataIndex];
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              let value = tooltipItems.formattedValue;
              if (value < 0) {
                value = value * -1;
              }
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.allUser[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people})`;
              } else if (
                tooltipItems.datasetIndex == 1 &&
                tooltipItems.dataset.backgroundColor[tooltipItems.dataIndex] ==
                  "#747474"
              ) {
                value = "0";
              }
              return `${label}: ${value}%`;
            },
          },
        };
        this.myChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.optionsMainPageMonthName,
            datasets: [
              {
                label: this.$t("insights.ACTIVE_USERS"),
                data: this.datachart.activeuser,
                allUser: this.datachart.alluser,
                backgroundColor: "#6C30CC",
                borderColor: "#6C30CC",
                stack: "combined",
                borderWidth: 2.5,
                pointRadius: 0,
                pointBorderWidth: 0,
              },
              {
                label: this.$t("insights.HAPPINESS"),
                data: happyData,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return backgroundColorBar;
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                  gradient.addColorStop(0, 'rgba(58, 196, 125, 0.65)');
                  gradient.addColorStop(0.5, 'rgba(58, 196, 125, 0.75)');
                  gradient.addColorStop(1, 'rgba(58, 196, 125, 0.85)');
                  return gradient;
                },
                borderColor: borderColorBar,
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
              {
                label: this.$t("insights.RISK"),
                data: riskData,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return 'rgba(244, 67, 54, 0.75)';
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                  gradient.addColorStop(0, 'rgba(244, 67, 54, 0.85)');
                  gradient.addColorStop(0.5, 'rgba(244, 67, 54, 0.75)');
                  gradient.addColorStop(1, 'rgba(244, 67, 54, 0.65)');
                  return gradient;
                },
                borderColor: "#F44336",
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
            ],
          },
          options: options,
        });
        this.dataMainPageChanged = false;
        this.$forceUpdate();
      }
    },
    remoteMainPage(rows, callback) {
      let response = [];
      if (this.selectMainPageSort == "1") {
        response = _.orderBy(
          rows,
          [
            function (o) {
              return o.happirate;
            },
          ],
          ["desc"]
        );
      } else if (this.selectMainPageSort == "2") {
        response = _.orderBy(
          rows,
          [
            function (o) {
              return o.riskrate;
            },
          ],
          ["asc"]
        );
      } else if (this.selectMainPageSort == "3") {
        response = _.orderBy(
          rows,
          [
            function (o) {
              return o.riskrate;
            },
          ],
          ["desc"]
        );
      } else {
        response = _.orderBy(
          rows,
          [
            function (o) {
              return o.happirate;
            },
          ],
          ["asc"]
        );
      }
      callback(response);
    },
    async changMainPageData(key) {
      await this.handleCohort(key);
    },
    async handleCohort(key) {
      await this.refreshMainScope(key);
    },
    async handleMainPageMonth(optMonth) {
      this.applyMainPeriodConfig(optMonth);
      await this.refreshMainChart();
    },
    async refreshMainScope(key = this.selectTeam) {
      const selectedCohort = key || this.getDefaultCohortSelection();
      const requestId = this.nextMainScopeRequestId();
      const chartRequestId = this.nextMainChartRequestId();
      const cohort = selectedCohort !== "all" ? selectedCohort : "";
      const cohortsState = this.$store.state.insightsCohorts;

      this.cohortStatusChanged = true;
      this.dataMainPageChanged = true;
      this.loadingMainData = true;
      this.selectTeam = selectedCohort;
      this.$store.commit("insightsCohorts/setCohortSelected", selectedCohort);
      this.$store.commit("insightsCohorts/setChartHappyRisk", []);
      this.$store.commit("insightsCohorts/setDataTable", []);
      this.resetMainTableExpansion();

      try {
        if (
          !cohortsState.insightcohortsByComp ||
          cohortsState.insightcohortsByComp.length === 0 ||
          !cohortsState.datalistall ||
          cohortsState.datalistall.length === 0
        ) {
          await this.$store.dispatch("insightsCohorts/getInsightCohortsByComp");
        }

        await this.$store.dispatch("insightsCohorts/getInsightCohorts", {
          selectCohort: cohort,
          activeWhere: this.activeWhere,
          requestKey: requestId,
        });

        await Promise.all([
          this.$store.dispatch("insightsCohorts/getDataTablebyCohort", {
            cohort,
            type: "parent",
            requestKey: requestId,
          }),
          this.refreshMainChart(chartRequestId),
        ]);
      } finally {
        if (requestId === this.mainScopeRequestId) {
          this.loadingMainData = false;
        }
      }
    },
    refreshMainChart(requestKey = null) {
      const chartRequestId = requestKey || this.nextMainChartRequestId();
      this.loadingMainChart = true;

      if (!this.optionsMainPageMonth.length) {
        this.$store.commit("insightsCohorts/setChartHappyRisk", []);
        if (chartRequestId === this.mainChartRequestId) {
          this.loadingMainChart = false;
        }
        return Promise.resolve();
      }

      this.dataMainPageChanged = true;
      this.$store.commit("insightsCohorts/setChartHappyRisk", []);
      this.$store.commit(
        "insightsCohorts/setSelectMonth",
        this.optionsMainPageMonth
      );
      return this.$store
        .dispatch("insightsCohorts/getDataChart", {
          value: this.optionsMainPageMonth,
          activeWhere: this.activeWhere,
          requestKey: chartRequestId,
        })
        .finally(() => {
          if (chartRequestId === this.mainChartRequestId) {
            this.loadingMainChart = false;
          }
        });
    },
    sortByMainPage(row) {
      this.selectMainPageSort = row.index;
      this.$store.dispatch(
        "insightsCohorts/sortDataTable",
        this.selectMainPageSort
      );
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 6) {
        return `
          background-image: linear-gradient(to bottom, #6C30CC 40%, rgba(255, 255, 255, 0) 20%);
          background-position: right;
          background-size: 1px 9px;
          background-repeat: repeat-y;
          padding-top: 7px;
        `;
      } else if (columnIndex == 12 || columnIndex == 13) {
        return "padding: 7px 6px;";
      } else if (columnIndex == 0 && this.blurMode) {
        return "filter: blur(4px); padding-top: 7px;"
      } else {
        return "padding-top: 7px;";
      }
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    truncateText(text, maxLength) {
      let length = maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    async exportChart(table) {
      this.$store.dispatch("insightsCohorts/getDataGraphExport", {
        table: table,
        activeWhere: this.activeWhere,
        filter: this.selectMainPageMonth,
        labeldate: this.newLabelsfulldate,
      });
    },
    compare(a, b) {
      let sortingBy = "happirate";
      let sortType = "asce";
      if (a && b) {
        if (this.selectMainPageSort == "3") {
          sortingBy = "riskrate";
          sortType = "desc";
        } else if (this.selectMainPageSort == "2") {
          sortingBy = "riskrate";
          sortType = "asce";
        } else if (this.selectMainPageSort == "1") {
          sortingBy = "happirate";
          sortType = "desc";
        } else {
          sortingBy = "happirate";
          sortType = "asce";
        }
        const sortA = a[sortingBy];
        const sortB = b[sortingBy];

        let comparison = 0;
        if (sortA > sortB) {
          comparison = 1;
        } else if (sortA < sortB) {
          comparison = -1;
        }
        if (sortType === "desc") {
          comparison = comparison * -1;
        }
        return comparison;
      } else {
        return undefined;
      }
    },
    load(tree, treeNode, resolve) {
      if (tree.children) {
        tree.children = tree.children.sort(this.compare);
        resolve(tree.children);
      } else {
        let childrenCohort = _(this.dataAllList)
          .thru(function (coll) {
            return _.union(coll, _.map(coll, "children") || []);
          })
          .flatten()
          .find({ id: tree.id });

        if (childrenCohort) {
          for (let i = 0; i < childrenCohort.children.length; i++) {
            if (childrenCohort.children[i].child_num > 0) {
              childrenCohort.children[i].hasChildren = true;
            }
          }
          childrenCohort.children = childrenCohort.children.sort(this.compare);
          resolve(childrenCohort.children);
          return;
        }
        resolve([]);
      }
    },
    renderPhaseHeader(h, { column }) {
      let className = "labelTable rotate";
      return h(
        "div",
        {
          class: className,
        },
        [
          h(
            "div",
            {
              class: "rotated-header-label",
            },
            column.label
          ),
        ]
      );
    },
    generateChartTooltipOnMain(value) {
      if (this.barChartTooltipBarChartOnMain) {
        this.barChartTooltipBarChartOnMain.destroy();
      }
      let chartLabel = [];
      let chartDataResigned = [];
      let chartDataTerminated = [];
      let chartDataAll = [];
      for(let i=5;i>=0;i--){
        chartLabel.push( this.$dateFns.format(addMonths(new Date(), -i), 'MMM'))

        const dateKey=this.$dateFns.format(addMonths(new Date(), -i), 'YYYY-MM')

        chartDataResigned.push(value.resigned[dateKey]?value.resigned[dateKey]:0)
        chartDataTerminated.push(value.terminate[dateKey]?value.terminate[dateKey]:0)

        const resigned=value.resigned[dateKey]?value.resigned[dateKey]:0
        const terminate=value.terminate[dateKey]?value.terminate[dateKey]:0
        chartDataAll.push(isNaN(terminate+resigned)?0:terminate+resigned)

      
      }

      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      var tooltipBarChart = this.$refs[value.id];
      options.plugins.datalabels = {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value, context) {
          return context.dataset.sumData[context.dataIndex];
        },
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
          stacked: true,
        },
        x: {
          stacked: true,
        },
      };
      options.animations = false;

      if (tooltipBarChart) {
        this.loadingChartInTable = false;
        const blankAll = [];
        chartDataTerminated.forEach((item, index) => {
          if (item > 0) {
            blankAll.push("");
          } else {
            blankAll.push(chartDataAll[index]);
          }
        });
        const tooltipBarchartDataResigned = {
          labels: chartLabel,
          datasets: [
            {
              data: chartDataResigned,
              sumData: blankAll,
              backgroundColor: "#F44336",
              stack: "Stack 0",
              borderRadius: 0,
            },
            {
              data: chartDataTerminated,
              sumData: chartDataAll,
              backgroundColor: "#FFBCB7",
              stack: "Stack 0",
              borderRadius: 0,
            },
          ],
        };
        this.barChartTooltipBarChartOnMain = new Chart(
          tooltipBarChart.getContext("2d"),
          {
            plugins: [chartDataResignedLabels],
            type: "bar",
            data: tooltipBarchartDataResigned,
            options: options,
          }
        );
      }
    },
    showingHistoryMainTable(value) {
      this.loadingChartInTable = true;
      this.generateChartTooltipOnMain(value);
    },
    showingHistoryMainEngagementTable(value) {
      this.hoverCohort = value
      this.$store.dispatch("insightsCohorts/getCohortEngagementScore", {
        selectCohort: value.id,
      })
    },
    generateChartTooltipOnMainEngagement() {
      let value = this.hoverCohort
      let chart = this.$refs['engagement_'+value.id];
      if(chart){
        var tooltipBarChart = this.$refs['engagement_'+value.id];
        if (tooltipBarChart) {
          const tooltipBarchartDataResigned = {
            labels: this.databarchartEngagementScore['labels'],
            datasets: [
              {
                data: this.databarchartEngagementScore['cohort'],
                borderColor: "#00ACC1",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#00ACC14A");
                    gradientFill.addColorStop(1, "#00ACC100");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['manager'],
                borderColor: "#E45006",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#E450064A");
                    gradientFill.addColorStop(1, "#E4500600");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['leader'],
                borderColor: "#D532C2",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#D532C24A");
                    gradientFill.addColorStop(1, "#D532C200");
                    return gradientFill;
                },
              },
            ],
          };
          this.barChartTooltipBarChartOnMainEngagement = new Chart(
            tooltipBarChart.getContext("2d"),
            {
              type: "line",
              data: tooltipBarchartDataResigned,
              options: {
                interaction: {
                  intersect: false,
                  mode: 'nearest'
                },
                maintainAspectRatio: false,
                scales: {
                  y: {
                    min: 0,
                    display: false,
                    ticks: {
                      stepSize: 50,
                      callback: function (value) {
                        return value;
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      font: {
                        color: 'black',
                        size: 12,
                        weight: 'bold',
                        family: "'Lato', 'Kanit', sans-serif"
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    formatter: function (value, context) {
                      return value;
                    },
                    font: {
                      weight: "bold",
                      size: 10,
                    },
                  },
                  tooltip: {
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                      title: (tooltipItems) => {
                        return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                      },
                      label: function (tooltipItems) {
                        const value = tooltipItems.formattedValue;
                        if(tooltipItems.datasetIndex == 0){
                          return ` Overall : ${value}`;
                        }else if(tooltipItems.datasetIndex == 1){
                          return ` Manager : ${value}`;
                        }else if(tooltipItems.datasetIndex == 2){
                          return ` Leader : ${value}`;
                        }
                      },
                    },
                    titleFont: {
                      weight: 'bold',
                    },
                  },
                },
                elements: {
                  line: {
                    tension: 0,
                  },
                },
                responsive: true,
                animations: false,
              },
            }
          );
        }
      }
    },
    detectColorTotal(value) {
      if(value == '-'){
        return "gray";
      }else if (value >= 60) {
        return "green";
      } else if (value < 60 && value >= 40) {
        return "yellow";
      } else {
        return "red";
      }
    },
    handleSearchInput() {
      // Force update the filtered data when search input changes
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.headerCard {
  display: flex;
  margin-top: 24px;
}
.headerCard2 {
  display: flex;
  margin-top: 36px;
}
.txtHeaderCard {
  font-size: 18px;
  font-weight: 700;
}
// Secondary-tier dropdown trigger: compact inline filter pill.
.menuOptionStyle {
  border-bottom: transparent;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  border-radius: 8px;
  transition: background-color .15s ease, border-color .15s ease;

  &:hover {
    background-color: #f6f7f9;
  }
}
.txtOption2 {
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 600;
  margin-left: 16px;
  width: 140px;
  display: inline-block;
}
.divTable {
  flex: 1;
  margin: 38px 0px 38px 0px;
}
.flexCenter {
  align-items: center;
}
.divCurcleStatus {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  padding: 12px;
}
.chart-bar {
  height: 217px;
  margin-top: 24px;
  background-color: rgba(0,0,0,0.03);
  border-radius: 4px;
  padding: 32px 24px 0;
  border-radius: 24px;
}
.loading-chart-bar {
  height: 50px;
  margin-top: 92px;
}
.chart-type-bar {
  width: 20px;
  height: 15px;
  border-radius: 4px;
}
.chart-type-bar.red {
  border: none;
  background: linear-gradient(to top, rgba(244, 67, 54, 0.65), rgba(244, 67, 54, 0.85));
}
.chart-type-bar.green {
  border: none;
  background: linear-gradient(to top, rgba(58, 196, 125, 0.65), rgba(58, 196, 125, 0.85));
}
.chart-type-bar.line {
  border: 1px solid #66bb6a00;
  background-color: #66bb6a00;
  > div {
    height: 2px;
    border-radius: 2px;
    background-color: #6c30cc;
    margin-top: 6px;
  }
}
.type-bar-text {
  color: #000;
  opacity: 0.6;
  font-size: 10px;
  margin: 0 16px 0 6px;
}
.chart-legend {
  display: flex;
  padding: 4px 12px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  align-items: center;
  margin: 6px 0 0 12px;
}

.chart-legend .symbol {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 8px;
}

.symbol.blue {
  background-color: #00ACC1;
}

.symbol.orange {
  background-color: #E45006;
}

.symbol.pink {
  background-color: #D532C2;
}

.search-container {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.search-input {
  width: 200px;
}

.search-input .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background: #f4f4f4;
  border: 1px solid transparent;
  font-size: 16px;
}

.search-input .el-input__inner:focus {
  border-color: #6C30CC;
}

.search-input .el-icon-search {
  color: #4a4a4a;
}
</style>
<style lang="scss">
#insightsCohorts > div > div.headerCard > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#insightsCohorts > div > div.headerCard2 > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#cohortsTable.el-table td {
  border-bottom: 0px solid #e6e5e4 !important;
}

#cohortsTable.el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: transparent;
}
#cohortsTable .th {
  .labelTable div {
    overflow: visible;
  }
  .rotate {
    -webkit-transform:
  /* Magic Numbers */ rotate(320deg);
    transform:
  /* Magic Numbers */ rotate(320deg);
    width: 60px;
  }
}

// Narrow fixed-width header columns (Happiness Rate / Risk Rate / Avg Impact /
// DEBI Score / 6-mo Retention) get clipped when combined with the global
// uppercase 11px nowrap treatment, because the column widths (58-90px) were
// designed for title-case labels. Scope an override: let these wrap to two
// lines at a tighter line-height so the full label reads.
#cohortsTable.el-table th > .cell {
  white-space: normal;
  line-height: 1.15;
  word-break: normal;
}
#cohortsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTable.is-leaf {
  overflow: unset;
  position: unset;
}
#cohortsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTable.is-leaf {
  padding: 40px 0 20px;
  overflow: unset;
  position: unset;
  > div {
    overflow: unset;
    position: unset;
    width: 100%;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    padding-left: 0px;
    padding-right: 0px;
    .rotate {
      position: unset;
      transform: rotate(315deg);
      width: 65px;
      overflow: visible;
      // Rotated diagonal label. Widened + force visible overflow so
      // AMBASSADORSHIP / REL COLLEAGUES / PERSONAL GROWTH / CO ALIGNMENT /
      // SATISFACTION render in full — the old `.ellipsis` class the header
      // used was clipping at 110px with text-overflow: ellipsis.
      .rotated-header-label {
        display: block;
        width: 200px;
        font-size: 10px;
        white-space: nowrap;
        overflow: visible !important;
        text-overflow: clip;
      }
    }
  }
}
#cohortsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelRateTable-spam.is-leaf {
  > div {
    font-size: 10px;
    line-height: 15px;
    padding-left: 6px;
    padding-right: 6px;
  }
  div.word-break {
    word-break: normal;
  }
}
#cohortsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelCohortTable.is-leaf
  > div {
  font-size: 14px;
  width: 325px;
}

#cohortsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td.tag
  > div {
  padding: 0;
  margin-left: auto;
}
#cohortsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td
  > div {
  color: #000;
  font-weight: 400;
  word-break: unset;
}
#cohortsTable .el-table__expand-icon {
  color: #000;
}
#cohortsTable .el-table__expanded-cell[class*="cell"] {
  padding: unset;
}
#cohortsTable.el-table th {
  border: 0;
  padding: 12px 0px 0px 0px;
  background-color: transparent;
}
#cohortsTable.el-table td {
  padding: 0px 0px 7px 0px;
  transition: 0.3s;
  &:first-of-type {
    border-radius: 6px 0 0 6px;
  }
  &:last-of-type {
    border-radius: 0 6px 6px 0;
  }
}
#cohortsTable.el-table .el-table__body tr {
  transition: 0.3s;
  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.03);
  }
}
</style>
